<script>
export default {
  name: "clean",
  created() {
    localStorage.clear();
    window.location.href = "/";
  }
}
</script>

<template>

</template>

<style scoped>

</style>